export enum SendTypeEnum {
  None = 0,
  Teams,
}
